import type { ReactNode } from 'react'
import { Button, RawButton } from '@/components/Button'
import { Icon } from '@/components/Icon'
import styles from './BookkeepingSelectCycleDialog.module.css'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetTitle,
  ModalSheetHeaderDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'

export interface BookkeepingSelectCycleDialogProps {
  showing: boolean
  onClose: () => unknown
  children?: ReactNode
}

export function BookkeepingSelectCycleDialog({
  showing,
  onClose,
  children,
}: BookkeepingSelectCycleDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader shellSize="sm" withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetTitle large>Select a cycle</ModalSheetTitle>
          <ModalSheetHeaderDescription>
            Choose the cycle you want to correct.
          </ModalSheetHeaderDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetContent>
        <div className={styles.cyclesList}>{children}</div>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            onPress={onClose}
            testId="select-cycle-close-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}

export interface BookkeepingSelectCycleListItemProps {
  number: number
  completionDate: string
  completedItems: string
  onSelect: () => unknown
}

export function BookkeepingSelectCycleListItem({
  number,
  completionDate,
  completedItems,
  onSelect,
}: BookkeepingSelectCycleListItemProps) {
  return (
    <RawButton
      className={styles.cycleItem}
      onPress={onSelect}
      testId={`select-cycle-item-${number}`}
    >
      <div className={styles.cycleItemInfo}>
        <div className={styles.title}>
          Cycle {number} ({completionDate})
        </div>
        <div className={styles.completedItems}>{completedItems}</div>
      </div>
      <div className={styles.arrowContainer}>
        <Icon className={styles.arrow} size={24} name="arrow" />
      </div>
    </RawButton>
  )
}
